import { Form, Formik } from "formik";
import React from "react";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import GetField from "../../components/GetField.jsx";
import ModalContainer from "../../components/ModalContainer.jsx";
import {
  initialValues,
  onSubmit,
  validationSchema,
} from "./editTicketStatusFormikCodes.js";

const options = [
  {
    text: "جاری",
    value: "o",
  },
  {
    text: "بسته شده",
    value: "c",
  },
];

const EditTicketStatus = () => {
  const location = useLocation();

  const navigate = useNavigate();

  const { setTickets } = useOutletContext();

  return (
    <ModalContainer
      alwaysOpen={true}
      fullscreen={false}
      title={`تغییر وضعیت تیکت "${location.state?.code}"`}
      className="max-w-screen-sm"
    >
      {location.state?.status && (
        <h3 className="mb-6 text-primary">
          آخرین وضعیت ثبت شده: &nbsp;
          <span className="font-bold">
            {location.state.status === "o"
              ? "جاری"
              : location.state.status === "c" && "بسته شده"}
          </span>
        </h3>
      )}
      <Formik
        initialValues={initialValues}
        onSubmit={(values, actions) =>
          onSubmit(values, actions, location.state, setTickets, navigate)
        }
        validationSchema={validationSchema}
        validateOnMount
      >
        {(formik) => {
          return (
            <Form className="flex flex-col">
              <div className="w-full sm:w-3/4 mb-4">
                <GetField
                  control="select"
                  name="status"
                  options={options}
                  label="وضعیت تیکت:"
                  title="وضعیت تیکت را انتخاب کنید"
                  formik={formik}
                />
              </div>
              {/* <div className="w-full">
                <input
                  type="checkbox"
                  id="send_sms"
                  name="send_sms"
                  onChange={formik.handleChange}
                  checked={formik.values.send_sms}
                />
                <label htmlFor="send_sms">ارسال پیامک</label>
              </div>
              <div className="w-full">
                <input
                  type="checkbox"
                  id="send_email"
                  name="send_email"
                  onChange={formik.handleChange}
                  checked={formik.values.send_email}
                />
                <label htmlFor="send_email">ارسال ایمیل</label>
              </div> */}
              <div className="w-full">
                <GetField
                  control="submitbutton"
                  disabledButton={true}
                  formik={formik}
                  text="تغییر وضعیت"
                />
              </div>
            </Form>
          );
        }}
      </Formik>
    </ModalContainer>
  );
};

export default EditTicketStatus;
